import React from 'react';
import { Helmet } from 'react-helmet';
import { loadSearchModel } from '../model/search';

interface SEOProps {
  language?: string;
  pageTitle?: string;
  pageDescription?: string;
  pageUrl?: string;
  pageType?: string;
}

const SEO: React.FC<SEOProps> = ({ language, pageTitle, pageDescription, pageUrl, pageType }) => {
  const searchModel = loadSearchModel(language);
  const { title, description, keywords, author, canonicalUrl, ogImage, locale } = searchModel.seo;

  const finalTitle = pageTitle || title;
  const finalDescription = pageDescription || description;
  const finalUrl = pageUrl || canonicalUrl;
  const finalType = pageType || 'website';

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      {finalUrl && <link rel="canonical" href={finalUrl} />}
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content={finalType} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:site_name" content="XTEA" />
      {finalUrl && <meta property="og:url" content={finalUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {locale && <meta property="og:locale" content={locale} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
};

export default SEO;
